export default "__VITE_ASSET__2V03TTLd__"